import React, { createContext, useState } from 'react'

const Context = createContext({})

export const Provider = ({ children }) => {
  const [state, setState] = useState({ data: {} })

  const getValue = (name, defaultValue = '') => state.data[name] || defaultValue

  const setValue = (name) => (value) => {
    setState((prevState) => ({
      data: {
        ...prevState.data,
        [name]: value
      }
    }))
  }

  const getValues = () => state.data

  const setField = (name) => (event) => {
    let { value } = event.target

    if (event.target.type === 'checkbox') {
      value = event.target.checked ? 'true' : 'false'
    }
    setValue(name)(value)
  }

  return (
    <Context.Provider value={{
      getValue, setValue, setField, getValues
    }}
    >
      {children}
    </Context.Provider>
  )
}

export default Context